import React from 'react'

const Footer = () => {
  return (
    <footer className="footer-system-bar">
      <div className="d-flex align-items-center gap-4 flex-wrap">
        <span className="footer-system-text">{new Date().getFullYear()} (c) FilterMarket</span>

        <div className="status-indicator" title="System Operational">
          <span className="d-none d-sm-inline">SYSTEM: OPERATIONAL</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
